import type { TagVariantType } from "common/components/ui/Tag";
import type { ApiKeyPermission } from "common/types";

import type { InvoiceStatus } from "./types";

export const BILLING_STATUSES: Record<
  InvoiceStatus,
  { label: string; bgClassname: string }
> = {
  paid: { label: "Paid", bgClassname: "bg-green-400" },
  posted: { label: "Posted", bgClassname: "bg-black-400" },
  pending: { label: "Invite sent", bgClassname: "bg-black-400" },
  not_paid: { label: "Not paid", bgClassname: "bg-red-500" },
  payment_due: { label: "Payment due", bgClassname: "bg-yellow-400" },
  voided: { label: "Voided", bgClassname: "bg-black-400" },
} as const;

export const API_KEYS_PERMISSIONS: Record<
  ApiKeyPermission,
  {
    label: string;
    tagVariant: TagVariantType;
    textColor: string;
    description?: string;
  }
> = {
  all: {
    label: "All",
    tagVariant: "primary",
    textColor: "text-purple-600",
    description:
      "“All” permission level allows full access to Aimfox resources. This key will allow any API call from our documentation",
  },
  "read-only": {
    label: "Read Only",
    tagVariant: "secondary",
    textColor: "text-purple-400",
    description:
      "“Read only” permission level allows read only access to Aimfox resources. This key will only allow access to GET API calls from our documentation",
  },
} as const;

export const WHITELABEL_DOMAIN =
  import.meta.env.MODE === "production" ? "lnconnect.me" : "linkedup.dev";
